// extracted by mini-css-extract-plugin
module.exports = {"gift-icon":"GiftNotificationIcon_gift-icon_3fgdv","notification":"GiftNotificationIcon_notification_2lElS"};